import { action, observable } from 'mobx';
import ILogTableStore from 'shared/containers/MobXLogTable/ITableStore';
import HistoryFileDownloadModel from 'shared/models/history/HistoryFileDownloadModel';
import HistoryFileDownloadSearchModel from 'shared/models/history/HistoryFileDownloadSearchModel';
import { RootStore } from 'shared/stores/RootStore';
import HistoryService from 'shared/services/HistoryService';
import uuid from 'uuid';
import AppConst from 'shared/utils/AppConst';

export class HistoryFileDownloadStore implements ILogTableStore<HistoryFileDownloadModel> {
  @observable
  inProgress: boolean;

  rootStore: RootStore;
  @observable
  searchModel: HistoryFileDownloadSearchModel;

  @observable
  dataSource: HistoryFileDownloadModel[];

  /** Actual number of records in DB */
  @observable
  totalCount: number;

  constructor(rootStore: any) {
    this.rootStore = rootStore;    
    this.resetStore();
  }

  @action
  export = async () => {
    try {
      const params = this.parseSearchModelToApiParams();
      const response = await HistoryService.exportFileDownloadHistories(params);
      this.rootStore.apiHandleStore.handleApiExport(response);
    } catch (error) {
      this.rootStore.apiHandleStore.handleApiError(error);
    }
  };

  @action
  find = async () => {
    try {
      this.inProgress = true;
      this.dataSource = Array<HistoryFileDownloadModel>();
      const histories = Array<HistoryFileDownloadModel>();

      const params = this.parseSearchModelToApiParams();
      const response = await HistoryService.findFileDownloadHistories(params);

      const { isSuccessful } = response.data.header;
      if (!isSuccessful) {
        this.inProgress = false;
        this.rootStore.apiHandleStore.handleApiFail(response.data.header);
        return;
      }

      const { empty, totalCount, results } = response.data.data;
      const data = results || [];
      const length = data ? data.length : 0;
      for (let index = 0; index < length; index++) {
        const element = data[index];
        element.no = index + 1;
        element.id = uuid.v4();
        element.changeStatus = AppConst.ActionType.READ;
        histories.push(element);
      }
      this.totalCount = totalCount || 0;
      this.dataSource = histories;
      this.inProgress = false;
    } catch (error) {
      this.inProgress = false;
      this.rootStore.apiHandleStore.handleApiError(error);
    }
  };

  @action
  setDataSource(dataSource: HistoryFileDownloadModel[]) {
    this.dataSource = dataSource;
  }

  getDataSource() {
    return this.dataSource;
  }

  /**
   * @Override
   */
  resetSearchModel() {
    this.searchModel = {
      userName: '',
      empNo: '',      
      downloadDateFrom: 0,
      downloadDateTo: 0,
      offset: 0
    };
  }

  parseSearchModelToApiParams = () => {
    const { userName, empNo, downloadDateFrom, downloadDateTo, offset } = this.searchModel;
    return {
      userName,
      empNo,      
      downloadDateFrom: this.trimDate(downloadDateFrom),
      downloadDateTo: this.trimDate(downloadDateTo),
      offset,
      limit: AppConst.LOG_TABLE_PAGE_SIZE
    };
  };

  trimDate = (dateValue: number) => {
    return dateValue > 0 ? dateValue : '';
  };

  /**
   * @Override
   */
  @action
  resetStore = () => {
    this.totalCount = 0;
    this.setDataSource(Array<HistoryFileDownloadModel>());
    this.resetSearchModel();    
  };
}
